import React, { Component } from 'react';
import { Row, Field, Label }  from '../../generic';
import { ToolTip } from '../../forms/eventFormComponents';
import TextInput from '../../generic/fields/TextInput';
import RadioInput from '../../generic/fields/RadioInput';
import { validRadio } from '../../../helpers/check-required-fields';
import styled from 'styled-components';

const Segment = styled.div`
  margin-bottom: 25px;
`

class Cancel extends Component {
  render() {
    const { userEvent, onChange } = this.props
    return (
      <React.Fragment>
        <h2 style={{marginBottom: '10px'}}>Cancel/Resume Your Gathering?</h2>
        
        <Segment>
        <p>Cancelling will prevent further RSVPs. If you change your mind, use Message All Guests to let them know.</p>
        </Segment>

        <Segment>
          <Field name="userEvent[cancelled]">
            <Label value="Event status" required={true} />
            <div>
              <RadioInput name="userEvent[cancelled]" onChange={onChange} checked={validRadio(userEvent.cancelled, false)} value={'false'} label="My event is happening"/>
            </div>
            <div>
              <RadioInput name="userEvent[cancelled]" onChange={onChange} checked={validRadio(userEvent.cancelled, true)} value={'true'} label="My event is cancelled"/>
            </div>
          </Field>
          {userEvent.cancelled && <p>Your gathering is marked as Cancelled. Be sure to Message All Guests to let them know. If you change your mind you can resume here.</p>}
        </Segment>
        
      </React.Fragment>
    )
  }
}

export default Cancel
